/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/329-sort-alpha-asc': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M5 12V0H3v12H.5L4 15.5 7.5 12H5zM14.5 16h-4a.5.5 0 01-.416-.777L13.566 10H10.5a.5.5 0 010-1h4a.5.5 0 01.416.777L11.434 15H14.5a.5.5 0 010 1zM15.947 6.276l-3-6a.5.5 0 00-.894 0l-3 6a.5.5 0 00.895.447l.862-1.724h3.382l.862 1.724a.5.5 0 00.895-.447zM11.309 4L12.5 1.618 13.691 4h-2.382z"/>'
  }
})
